import { neutral60opacity05 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
import { dialogContentOffset } from './MuiDialogContent';
export var MuiDialogTitle = {
    styleOverrides: {
        root: {
            alignItems: 'center',
            display: 'flex',
            padding: 0,
            '&&+.MuiDialogContent-root': {
                paddingTop: dialogContentOffset,
            },
        },
    },
    customOverrides: {
        header: {
            backgroundColor: neutral60opacity05,
        },
        filled: {
            backgroundColor: neutral60opacity05,
            '& > .MuiTypography-root': {
                paddingBlock: rem(16),
                paddingInline: rem(24),
            },
        },
        iconAndFilled: {
            '& > .MuiTypography-root': {
                padding: '0',
            },
        },
        title: {
            fontWeight: 600,
            fontSize: '1.375rem',
            flexGrow: 1,
            padding: rem(24),
            paddingBottom: 0,
        },
        titleWithIcon: {
            padding: 0,
            marginInlineEnd: rem(24),
        },
        titleBarButtons: {
            display: 'flex',
            gap: rem(8),
            marginBottom: 'auto',
            marginInlineEnd: rem(8),
            marginTop: rem(8),
        },
    },
};
